import './src/vaadin-form-item.js';
export * from './src/vaadin-form-item.js';
